import { render } from "./PortfolioProjectsBlock.vue?vue&type=template&id=7add294c"
import script from "./PortfolioProjectsBlock.vue?vue&type=script&lang=js"
export * from "./PortfolioProjectsBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__